export default __webpack_public_path__ + "static/media/RhysHoward.74769b07.jpg";